module.exports = __webpack_public_path__ + "img/adress.3ac5c37c.png";